<template>
  <div class="unknown-block">
    <p>Unknown block type: {{ block.__typename }}</p>
    <pre>{{ JSON.stringify(block, null, 2) }}</pre>
  </div>
</template>

<script setup lang="ts">
interface Props {
  block: {
    __typename: string
    id: string
    [key: string]: any
  }
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.unknown-block {
  padding: 1rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin: 1rem 0;
  
  p {
    color: #dc3545;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  pre {
    background-color: #f1f3f4;
    padding: 0.5rem;
    border-radius: 4px;
    font-size: 0.875rem;
    overflow-x: auto;
  }
}
</style> 